import { Button } from "@material-ui/core";
import React, { useRef } from "react";
import { useEffect } from "react";
import { useState } from "react";

const LS_NAME = 'audioMessageRate';

const resolveAudioMimeType = (url = "") => {
    const normalizedUrl = `${url}`.split("?")[0].toLowerCase();

    if (normalizedUrl.endsWith(".mp3")) return "audio/mpeg";
    if (normalizedUrl.endsWith(".m4a") || normalizedUrl.endsWith(".mp4")) return "audio/mp4";
    if (normalizedUrl.endsWith(".webm")) return "audio/webm";
    if (normalizedUrl.endsWith(".wav")) return "audio/wav";

    return "audio/ogg";
};

export default function({url}) {
    const audioRef = useRef(null);
    const [audioRate, setAudioRate] = useState( parseFloat(localStorage.getItem(LS_NAME) || "1") );
    const [showButtonRate, setShowButtonRate] = useState(false);

    useEffect(() => {
        if (!audioRef.current) {
            return;
        }

        audioRef.current.playbackRate = audioRate;
        localStorage.setItem(LS_NAME, audioRate);
    }, [audioRate]);

    useEffect(() => {
        if (!audioRef.current) {
            return undefined;
        }

        audioRef.current.onplaying = () => {
            setShowButtonRate(true);
        };
        audioRef.current.onpause = () => {
            setShowButtonRate(false);
        };
        audioRef.current.onended = () => {
            setShowButtonRate(false);
        };

        return () => {
            if (!audioRef.current) {
                return;
            }

            audioRef.current.onplaying = null;
            audioRef.current.onpause = null;
            audioRef.current.onended = null;
        };
    }, []);

    const toogleRate = () => {
        let newRate = null;

        switch(audioRate) {
            case 0.5:
                newRate = 1;
                break;
            case 1:
                newRate = 1.5;
                break;
            case 1.5:
                newRate = 2;
                break;
            case 2:
                newRate = 0.5;
                break;
            default:
                newRate = 1;
                break;
        }
        
        setAudioRate(newRate);
    };

    return (
        <>
            <audio ref={audioRef} controls preload="metadata">
                <source src={url} type={resolveAudioMimeType(url)}></source>
                <source src={url} type="audio/mpeg"></source>
                <source src={url} type="audio/mp4"></source>
                <source src={url} type="audio/ogg"></source>
                <source src={url} type="audio/webm"></source>
            </audio>
            {showButtonRate && <Button style={{marginLeft: "5px", marginTop: "-45px"}} onClick={toogleRate}>{audioRate}x</Button>}
        </>
    );
}
